const BRANCH_LINK = 'https://trucksmarter.app.link/app-store';

export default BRANCH_LINK;
